import { IconButton, Typography, Stack } from "@mui/material";
import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";
import type { QtyCounterProps } from "../Services.types";

export const QtyCounter = ({ val, min, max, onChange }: QtyCounterProps) => {
  return (
    <Stack direction="row" sx={{ alignItems: "center" }} spacing={1}>
      <IconButton
        size="small"
        onClick={() => onChange(val - 1)}
        disabled={val <= min}
        sx={{ border: "1px solid", borderColor: "divider" }}
      >
        <RemoveIcon fontSize="small" />
      </IconButton>
      <Typography
        variant="body1"
        sx={{
          minWidth: 40,
          textAlign: "center",
          fontWeight: 600,
        }}
      >
        {val}
      </Typography>
      <IconButton
        size="small"
        onClick={() => onChange(val + 1)}
        disabled={max !== undefined && val >= max}
        sx={{ border: "1px solid", borderColor: "divider" }}
      >
        <AddIcon fontSize="small" />
      </IconButton>
    </Stack>
  );
};
